<nav>
  <app-banner></app-banner>
  <app-widget-bar></app-widget-bar>
</nav>
<app-grid></app-grid>
<main>
  <router-outlet></router-outlet>
</main>
